import { Input } from 'semantic-ui-react';
export default Input;